module.exports = __webpack_public_path__ + "static/SSTArabic-Light-4dab16885b6e6cac9f31e7e8a025897f.otf";